import { useContext, useState } from 'react';
import { List, ListItem, ListItemText, Menu, MenuItem } from '@mui/material';
import { Link } from 'react-router-dom';
import { Settings } from '@mui/icons-material';
// import { applicationContext, appUserContext } from 'helpers/services';


let AdminMenu = () => {
    // let { currentUser } = useContext(appUserContext);

    let [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

    let handleOpen = (e: any) => setAnchorEl(e.currentTarget);

    let onClose = () => setAnchorEl(null);


    return (
        <>
            <List component="nav" disablePadding>
                <ListItem button onClick={(e) => handleOpen(e)}>
                    <ListItemText primary={<Settings />} />
                </ListItem>
            </List>

            <Menu
                anchorEl={anchorEl}
                keepMounted
                open={anchorEl !== null}
                onClose={onClose}
            >
                {/* {currentUser?.canManageVitecUsers && */}
                <MenuItem component={Link} to={'/admin/warehouse'} onClick={onClose}>Warehouse</MenuItem>
                <MenuItem component={Link} to={'/admin/channel'} onClick={onClose}>Channels</MenuItem>
                <MenuItem component={Link} to={'/admin/country'} onClick={onClose}>Countries</MenuItem>
                <MenuItem component={Link} to={'/admin/inventory'} onClick={onClose}>Inventory</MenuItem>
                <MenuItem component={Link} to={'/admin/carrier'} onClick={onClose}>Carriers</MenuItem>
                <MenuItem component={Link} to={'/admin/shipmenttypes'} onClick={onClose}>Shipment Types</MenuItem>
                <MenuItem component={Link} to={'/admin/referencedata'} onClick={onClose}>Reference data</MenuItem>
                <MenuItem component={Link} to={'/admin/countrytaxrate'} onClick={onClose}>Countries tax rate</MenuItem>
                <MenuItem component={Link} to={'/admin/user'} onClick={onClose}>Users</MenuItem>
                {/* } */}
            </Menu>
        </>
    )
}

export default AdminMenu;